var map = {
	"./product0.png": "czu9",
	"./product1.png": "TUl7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hXlf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/product.*\.png$
// module id = hXlf
// module chunks = 3